import ModalCloseButton from 'components/buttons/ModalCloseButton'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { setViewEditVideoModal, updateVideo } from 'features/videos/videoSlice'
import { setViewAudioUpdateModal, updateAudio } from 'features/audio/audioSlice'
import { FileUploadButton } from 'components/files/files.styled'
import SpinnerSmall from 'components/SpinnerSmall'
import { LuListVideo } from "react-icons/lu";
import { MediaUpdateModal } from '../media.styled'
import { useTranslation } from 'react-i18next'

export default function EditAudioModal() {
    const { t } = useTranslation('media')

    
    const dispatch = useDispatch()
 
    const { profileChurch } = useSelector(state => state.profileChurch)
    const { audioData, audioUpdateLoading } = useSelector(state => state.audio)

    const [title, setTitle] = useState('')

    useEffect(() => {
        if(audioData){
            setTitle(audioData.title)
        }
    }, [audioData])

    const handleUpdateAudio = () => {

        if(title === ''){
            return
        }

        dispatch(updateAudio({
            title: title,
            audioId: audioData._id,
            churchId: profileChurch._id,
        }))

    }

    return (
        <MediaUpdateModal> 
            <ModalCloseButton
                handler={() => dispatch(setViewAudioUpdateModal(false))}
                top={'20px'} right={'20px'} size='30px'
                /> 
            <h1> 
                <LuListVideo style={{marginRight: '10px', fontSize: '20px'}}  />
                {t('editAudio')}
            </h1>

            <EVFC>
                <label>{t('title')}</label>
                <input 
                    type='text' 
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    />
            </EVFC>

            <div
                style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'flex-end', marginTop: '40px'}}
                >
                <FileUploadButton
                    disabled={audioUpdateLoading} 
                    onClick={handleUpdateAudio}
                    >
                    {
                        audioUpdateLoading ? 
                        (
                            <SpinnerSmall />
                        )
                        :
                        (
                            t('save')
                        )
                    }
                </FileUploadButton>
            </div> 

        </MediaUpdateModal>
    )
}

const EVFC = styled.div`    
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;
    transition: all 0.6s ease-in-out;

    label{
        font-size: 13px;
        color: var(--lightThemeFontColor);
        margin-bottom: 5px;
    }

    input{
        padding: 10px;
        border: 1px solid var(--lightThemeBorderColor);
        color: var(--lightThemeFontColor);
        border-radius: 5px;
        background-color: aliceblue;
        border: 2px solid transparent;
    } 

    /* on input focus */
    input:focus{
        outline: 2px solid var(--themeColor);
    }

`
 

